import React from 'react';
import styles from './EnrolledSuccessModal.module.css';

/**
 * Post-enrollment celebration modal (manual close only).
 * Shows the PrrepX vision + what the student unlocked.
 */
const EnrolledSuccessModal = ({ programLabel, studentName, onClose }) => {
  if (!programLabel) return null;
  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Enrollment successful">
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">✕</button>
        <div className={styles.ribbon} />

        <div className={styles.body}>
          <div className={styles.check}>🎉</div>
          <h3 className={styles.heading}>You're enrolled{studentName ? `, ${studentName.split(' ')[0]}` : ''}!</h3>
          <p className={styles.sub}>
            Welcome to <strong>{programLabel}</strong> — happy learning! Your progress is now being tracked.
          </p>

          <div className={styles.unlocked}>
            <p className={styles.unlockedTitle}>Here's what you just unlocked:</p>
            <ul className={styles.unlockedList}>
              <li>📈 <span>Every lecture, DPP & test you finish is <strong>tracked</strong> — watch your progress bar grow.</span></li>
              <li>🏅 <span><strong>Earn a badge</strong> for every chapter you complete.</span></li>
              <li>📜 <span><strong>Get a certificate</strong> when you finish a full subject.</span></li>
              <li>🔥 <span>Stay consistent — small daily wins compound into a rank.</span></li>
            </ul>
          </div>

          <div className={styles.vision}>
            <p className={styles.visionTitle}>The PrrepX Promise</p>
            <ul className={styles.visionList}>
              <li>🎓 100% faculties from IIT/NIT & top medical alumni.</li>
              <li>🌐 One-stop solution for JEE / NEET / Class 6–12.</li>
              <li>💚 100% free — no barriers, no paywalls. Ever.</li>
            </ul>
          </div>

          <button type="button" className={styles.ctaBtn} onClick={onClose}>
            Start Learning →
          </button>
          <p className={styles.note}>You're one step closer to your dream. Let's do this together.</p>
        </div>
      </div>
    </div>
  );
};

export default EnrolledSuccessModal;
